import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('usuario', 'usuario');

const usuarioActions = {
  listarAtivos: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true` },
  listarTodos: { method: 'GET', url: `${basePath}?nome={nome}` },
  listar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}` },
  listarUsuariosFornecedores: { method: 'GET', url: `${basePath}/fornecedor?tamanhoPagina={size}&numeroPagina={page}{&idsGrupoFornecedor*}{&statusFluxo*}{&indUsuarioExternoMaster*}` },
  buscar: { method: 'GET', url: `${basePath}/{id}` },
  buscarNoOmni: { method: 'GET', url: `${basePath}/{tipo}/omni/{email}` },
  buscarTenantsUsuario: { method: 'GET', url: `${basePath}/{idUsuario}/tenants` },
  buscarTenantsUsuarioAtivo: { method: 'GET', url: `${basePath}/{idUsuario}/tenants?indAtivo=true` },
  buscarTenantsUsuarioLogado: { method: 'GET', url: `${basePath}/usuario-logado/tenants` },
  listarAtivosResumido: { method: 'GET', url: `${basePath}/resumido?nome={nome}&indAtivo=true{&ids*}` },
  listarSuperior: { method: 'GET', url: `${basePath}/superior` },
  informacao: { method: 'GET', url: `${basePath}/informacao` },
  enviarEmailNotificacaoEdicaoDadosSensiveis: { method: 'PUT', url: `${basePath}/enviar-email-notificacao-edicao-dados-sensiveis` },
  dadosSensiveisAlteracao: { method: 'POST', url: `${basePath}/dados-sensiveis-alteracao` },
  listarConfiguracao: { method: 'GET', url: `${basePath}/configuracao` },
  buscaUltimaAlteracao: { method: 'GET', url: `${basePath}/ultima-alteracao/{idUsuario}` },
  dadosFluxosAprovacaoImpactados: { method: 'GET', url: `${basePath}/dados-fluxos-aprovacao-impactados/{idUsuario}` },
  buscaTermoAceiteUsuarioCadastro: { method: 'GET', url: `${basePath}/busca-termo-aceite-cadastro/{idUsuario}` },
  gravar: { method: 'POST', url: `${basePath}` },
  atualizar: { method: 'PUT', url: `${basePath}` },
  aprovarUsuarioMaster: { method: 'PUT', url: `${basePath}/aprovar-usuario-master` },
  buscarFluxoAprovacao: { method: 'GET', url: `${basePath}/buscar-fluxo-aprovacao/{idUsuario}` },
  buscarUsuariosRepresentantesLegais: { method: 'GET', url: `${basePath}/buscar-usuarios-representantes-legais/{idGrupoFornecedor}` },
  buscarTodosGruposFornecedores: { method: 'GET', url: `${basePath}/grupo-fornecedor` },
  setarRolesPerfilLogado: { method: 'PUT', url: `${basePath}/role/setar-roles-perfil-logado` },
  buscaDadosMensagemAvisoLogin: { method: 'GET', url: `${basePath}/busca-dados-mensagem-aviso-login/{tipoUsuario}` },
};

export default (resource) => resource(`${basePath}`, {}, usuarioActions);
